var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-function"
  }, [_c("section", {
    staticClass: "product-function__title area"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("FUNCTION")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("功能介绍")])]), _c("section", {
    staticClass: "product-function__introduction"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };